import SignIn from "../../components/SalesPersonModule/Login/Login";
import Dashboard from "../../components/SalesPersonModule/dashboard";
import CustomerList from "../../components/SalesPersonModule/Customer/Customer-list";
import CreateCustomer from "../../components/SalesPersonModule/Customer/Create-customer";
import Profile from "../../components/SalesPersonModule/Profile/Edit-profile";
import InstallmentList from "../../components/SalesPersonModule/Installment/Installment-List";
import InstallmentView from "../../components/SalesPersonModule/Installment/Installment-View";
import InstallmentSalesForm from "../../components/SalesPersonModule/Installment/Installment-Sales-Form";
import InstallmentUpdate from "../../components/SalesPersonModule/Installment/Installment-Update";
import Product from "../../components/SalesPersonModule/Product/Product-list";

const routes = [
  {
    path: "/salesperson/login",
    exact: true,
    auth: false,
    element: <SignIn />,
  },
  {
    path: "/salesperson/dashboard",
    exact: true,
    auth: true,
    element: <Dashboard />,
  },
  {
    path: "/salesperson/customer-list",
    exact: true,
    auth: true,
    element: <CustomerList />,
  },
  {
    path: "/salesperson/customer/create",
    exact: true,
    auth: true,
    element: <CreateCustomer />,
  },
  {
    path: "/salesperson/profile",
    exact: true,
    auth: true,
    element: <Profile />,
  },
  {
    path: "/salesperson/installment-list",
    exact: true,
    auth: true,
    element: <InstallmentList />,
  },
  {
    path: "/salesperson/installment-sales-form/view",
    exact: true,
    auth: true,
    element: <InstallmentView />,
  },
    {
    path: "/salesperson/installment-sales-form",
    exact: true,
    auth: true,
    element: <InstallmentSalesForm />,
  },
  {
    path: "/salesperson/installment-sales-form/update",
    exact: true,
    auth: true,
    element: <InstallmentUpdate />,
  },
  {
    path: "/salesperson/product-list",
    exact: true,
    auth: true,
    element: <Product />,
  },
];

export default routes;
